export const toFixed5 = (value) => Number(value.toFixed(5));

export const toFixed3 = (value) => Number(value.toFixed(3));

export const toFixed2 = (value) => Number(value.toFixed(2));

export const formatNumber = (number) => (number ? number.toLocaleString("en-US") : 0);

export const roundTo2 = (number) => Math.round((Number(number) + Number.EPSILON) * 100) / 100;
